// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".heading[data-v-0ba47218]{font-weight:700;font-size:14px}.delivery-sequence-number[data-v-0ba47218]{font-weight:400}hr[data-v-0ba47218]{border-top:1px solid #c1c1c1;margin:0}.delivery-when[data-v-0ba47218]{display:flex;column-gap:.5em}.total-by-each-checkout[data-v-0ba47218]{width:100%}.total-by-each-checkout--row[data-v-0ba47218]{display:flex;justify-content:space-between}.total-by-each-checkout--row div[data-v-0ba47218]{font-size:14px}", ""]);
// Exports
module.exports = exports;
